// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--3GV48","inverted":"button-module--inverted--uEU0f"};